<template>
  <div class="grade">
    <van-cell>
      <template slot="title">
        <van-row class="title text-c" type="flex" justify="space-between">
          <van-col span="5">等级</van-col>
          <van-col span="10">特权</van-col>
          <van-col span="4">经验</van-col>
        </van-row>
      </template>
    </van-cell>
    <van-list
    v-model="loading"
    :finished="finished"
    finished-text="已加载全部"
    @load="onLoad"
    >
    <div slot="loading" class="list-loading">
      <img :src="this.img.loading" />
    </div>
    <van-cell v-for="item in list" :key="'list_' + item.id">
      <template slot="title">
       <van-row type="flex" justify="space-between">
        <van-col class="text-c linheight" span="5"><div class="f-w f-17"><img class="lv" :src="img.lv">{{item.level}}</div></van-col>
        <van-col span="10">
          <div class="fontpub">· {{item.privilege}}</div>
        </van-col>
        <van-col class="fontpub text-c linheight" span="4">{{item.exp}}</van-col>
      </van-row>
    </template>
  </van-cell>
</van-list>
</div>
</template>
<script>
  import common from '../../../api/common';
  import member from '../../../api/member/memberinfo';
  import { mapState } from 'vuex';
  import { List, Row, Col,Cell, CellGroup } from 'vant';
  export default {
    data () {
      return {
        loading: false,
        finished: false,
        params:{
          source:'',
          page:1,
          size:10
        },
        list:[],
        img:{
          loading: require('../../../assets/img/loading_lexus.gif'),
          lv: require('../../../assets/img/lexus/my/lv.png')
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: true})
      this.$appService.isTabbar({state: true})
      this.params.source=this.source
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          this.$appService.needLogin()
        }
      })
      var params={
        event_code: '等级特权',
        event_id: '',
        title: '',
        value: '',
        path: '/Lexus/My/MyGradeInfo.vue',
        user_id: this.user ? this.user.id : 0,
        source: this.source
      }
      common.BurialPoint(params).then(res => {
        if(res.data.state==1){
        }
      })
      var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
    },
    methods: {
      onLoad(){
       setTimeout(() => {
        member.getGradeInfo(this.params).then(res => {
          this.list.push.apply(this.list, res.data.data.data)
          this.params.page += 1
          this.loading = false
          if(res.data.data.data.length == 0) {
            this.finished = true
          }
        })
      }, 500);
     }
   },
   components: {
    [List.name]: List,
    [Row.name]: Row,
    [Col.name]:Col,
    [Cell.name]: Cell,
    [CellGroup.name]:CellGroup
  }
}
</script>
<style lang="scss">
.grade{
  .title{
    font-size: 12px;
    color: #9A9A9A;
  }
  .fontpub{
    font-size: 12px;
    color: #3A3A3A;
  }
  .lv{
    font-size: 12px;
    width: 17px;
  }
  // .linheight{
  //   line-height: 50px;
  // }
  .van-cell:not(:last-child)::after{
    left: 0;
    border-bottom: 0 solid #ebedf0;
  }
  .van-cell{
    border-bottom: 0.026667rem solid #ebedf0;
  }
}
</style>
